
        <div class="ui-dropdown-container" #container
            (mouseenter)="onDropdownHandler($event, dropdown, container)"
            (mouseleave)="onMouseLeave($event, dropdown, container)"
            (click)="onDropdownHandler($event, dropdown, container)">
            <ng-content></ng-content>
            <div class="ui-dropdown" #dropdown
                [style.display]="dropdownVisible ? 'block' : 'none'"
                [style.max-height]="_maxHeight">
                <ul class="ui-dropdown-items">
                    <li class="ui-dropdown-item" *ngFor="let item of dataSource"
                        [class.active]="item===chosen"
                        [style.min-width.px]="width">
                        <a [href]="item.url||'javascript:void(0);'" 
                        [ngClass]="{'ui-dropdown-item-link':true,
                        'ui-dropdown-item-disabled':item.disabled}" 
                        (click)="itemClick($event,item)"
                        [style.color]="item.color">
                            <span class="ui-dropdown-item-text">{{item.label}}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    